import React, { useEffect, useState } from 'react'

interface ModalSimpleProps {
  size?: string
  dataTest?: string
  className?: string
  children?: React.ReactNode
}

const ModalSimple: React.FC<ModalSimpleProps> = ({
  size = 'lg',
  dataTest,
  className = '',
  children,
}) => {
  const [animation, setAnimation] = useState('')

  useEffect(() => {
    setTimeout(() => {
      setAnimation('in show')
      document.body.style.overflow = 'hidden'
    }, 100)
    return () => {
      document.body.style.overflow = 'auto'
    }
  }, [])

  return (
    <div
      className={`sh modal fade ${animation} ${className}`}
      tabIndex={-1}
      role="dialog"
      style={{ display: 'block' }}
      data-test={dataTest ?? 'modal'}
    >
      <div className={`modal-dialog modal-${size} modal-au`} role="document">
        {children}
      </div>
    </div>
  )
}

export default ModalSimple
